import PropTypes from 'prop-types';
import React from 'react';
import Label from 'shared/components/label';
import Dropdown from 'src/components/dropdown';
import {MONTH_FULL} from 'shared/utils';

class MonthDropdown extends React.Component {
  static propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    error: PropTypes.string,
    onChange: PropTypes.func,
    months: PropTypes.array,
    label: PropTypes.string,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
  };

  static defaultProps = {
    months: MONTH_FULL.map((month, index) => ({_id: '' + index, value: '' + index, text: month})),
    label: 'Month',
  };

  render() {
    const {months, onChange, label, required, disabled, value, error} = this.props;

    return (
      <Label {...{required}}>
        {label}
        <Dropdown
          required={required}
          options={months}
          value={value}
          error={error}
          cy="month-dropdown"
          testid="month-dropdown"
          onChange={onChange}
          disabled={disabled}
        />
      </Label>
    );
  }
}

export default MonthDropdown;
